// A date for display, or a calm fallback when the value is missing or unreadable.
// (15 October 2026: coach screens showed "Invalid Date" for incomplete records.)
export const formatDateOr = (value, options, fallback = 'Date unavailable', method = 'toLocaleDateString') => {
  if (value === null || value === undefined || value === '') return fallback;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return fallback;
  return d[method]('en-US', options);
};
